import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import classNames from 'classnames';

import { StoreState } from '@mm/state/store-interfaces';
import { hideSlideoutMenu } from '@mm/state/actions/viewActions';

import { SlideoutMenu as Menu } from '../../components/SlideoutMenu';
import { useDetectOutsideClicks } from '../../../../../common/hooks/use-detect-outside-clicks';

import css from './SlideoutAutomationAction.module.css';

export type ISlideoutAutomationAction = {
  dialogueId: number;
  sortOrder: number;
  className?: string;
  onSlideoutClose?: () => {};
};

export const SlideoutAutomationAction = (props: ISlideoutAutomationAction) => {
  const { className, onSlideoutClose = () => {} } = props;
  const dispatch: Dispatch<StoreState> = useDispatch();

  const onCloseClick = () => {
    dispatch(hideSlideoutMenu());
    onSlideoutClose();
  };
  const [wrapperRef, setWrapperRef] = useState<HTMLElement | null>(null);

  useDetectOutsideClicks(() => {
    onCloseClick();
  }, wrapperRef);

  const setRef = (ref: HTMLElement) => {
    setWrapperRef(ref);
  };

  return (
    <Menu className={classNames(className, css.action)} setRef={setRef}>
      <></>
    </Menu>
  );
};
